import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'wk-confirm-cancel-checkout',
  templateUrl: 'wk-confirm-cancel-checkout.component.html',
  styleUrls: ['./wk-confirm-cancel-checkout.component.scss'],
})
export class WkConfirmCancelCheckoutComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private readonly dialogRef: MatDialogRef<WkConfirmCancelCheckoutComponent>
  ) {}

  close(confirmed = false) {
    this.dialogRef.close(confirmed);
  }
}
